/* eslint-disable @typescript-eslint/no-explicit-any */
import { isClient } from './ssr';

export type StorageType = 'localStorage' | 'sessionStorage';

export function getItem<T = any>(key: string, parse = true, storageType: StorageType = 'localStorage'): T | null {
  if (!isClient()) {
    return null;
  }

  try {
    const storageItem = window[storageType].getItem(key);
    if (storageItem) {
      return parse ? JSON.parse(storageItem) : storageItem;
    }
    return null;
  } catch (e) {
    console.error('Web Storage API is not supported', e);
    return null;
  }
}

export function setItem(key: string, value: any, stringify = true, storageType: StorageType = 'localStorage'): void {
  if (!isClient()) {
    return;
  }

  try {
    window[storageType].setItem(key, stringify ? JSON.stringify(value) : value);
  } catch (e) {
    console.error('Web Storage API is not supported', e);
  }
}

export function removeItem(key: string, storageType: StorageType = 'localStorage'): void {
  if (!isClient()) {
    return;
  }

  try {
    window[storageType].removeItem(key);
  } catch (e) {
    console.error('Web Storage API is not supported', e);
  }
}

export const createStorageKey = (key: string, locale: string): string => {
  if (!locale) {
    return key;
  }

  const countryCode = locale.split('-')[1]?.toUpperCase();

  return countryCode ? `${key}_${countryCode}` : key;
};

export function addToStorageArray<T>(storageKey: string, data: T, storageType: StorageType = 'localStorage'): void {
  if (!isClient()) {
    return;
  }

  let existingData: T[] = [];

  try {
    const storedData = window[storageType].getItem(storageKey);
    if (storedData) {
      existingData = JSON.parse(storedData);
    }
  } catch (e) {
    console.error('Web Storage API is not supported', e);
  }

  existingData.push(data);
  setItem(storageKey, existingData, true, storageType);
}
